var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReset = function SvgReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1232,
    height: 634,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "143-charts--main-layout--zoom-controls--color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1163.000000, -462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app-body",
    transform: "translate(23.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(1.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(0.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "metrics-on-charts",
    transform: "translate(81.000000, 81.000000)",
    stroke: "#96C93D",
    strokeDasharray: 1,
    strokeLinecap: "square",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "chart",
    points: "0 166 3.70219966 171 7.40439932 139 14.8087986 184 20.3620981 188 24.0642978 172 27.7664975 196 31.4686971 164 37.0219966 186 40.7241963 148 46.2774958 166 55.5329949 147 59.2351946 160 64.7884941 147 68.4906937 162 75.8950931 217 85.1505922 162 94.4060914 145 98.108291 158 105.51269 151 109.21489 128 112.91709 164 116.619289 150 120.321489 161 124.023689 144 133.279188 287 142.534687 120 149.939086 142 155.492386 126 164.747885 137 174.003384 124 179.556684 133 188.812183 124 194.365482 181 201.769882 174 211.025381 191 216.57868 174 220.28088 166 225.834179 93 233.238579 128 240.642978 114 244.345178 126 253.600677 119 259.153976 128 268.409475 10 277.664975 174 290.622673 189 294.324873 174 303.580372 124 314.686971 137 320.240271 124 329.49577 137 335.049069 124 344.304569 144 351.708968 119 359.113367 404 361.618305 304.881592 366.517766 156 375.773266 147 381.326565 158 390.582064 131 397.986464 156 409.093063 145 418.348562 156 429.455161 150 442.41286 165 451.668359 145 455.370558 193 460.923858 164 466.477157 191 472.030457 178 479.434856 184 486.839255 144 490.541455 168 497.945854 164 503.499154 175 505.350254 123 514.605753 165 520.159052 153 525.712352 165 531.265651 130 536.818951 164 540.521151 148 549.77665 169 553.478849 153 559.032149 156 562.734349 141 570.138748 151 579.394247 143 583.096447 137 588.649746 141 592.351946 126 597.905245 129 599.756345 95 605.309645 155 610.862944 121 621.969543 134 627.522843 116 634.927242 126 642.331641 135 647.884941 130 655.28934 126 658.99154 114 666.395939 131 675.651438 117 681.204738 140 688.609137 137 696.013536 143 701.566836 138 708.971235 145 720.077834 115 725.631134 146 734.886633 212 738.588832 140 747.844332 134 757.099831 261 762.65313 110 775.610829 150 781.164129 124 788.568528 150 794.121827 140 803.377327 147 812.632826 137 821.888325 145 829.292724 119 840.399323 126 849.654822 119 858.910321 126 870.01692 119 877.42132 126 886.676819 165 894.081218 89 907.038917 142 918.145516 133 925.549915 148 942.209814 166 947.763113 148 957.018613 164 968.125212 147 979.23181 158 982.93401 174 997.742809 164 1006.99831 172 1016.25381 162 1025.50931 170 1038.46701 157 1051.4247 164 1064.3824 146 1075.489 138 1094 124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "zoom-controls",
    transform: "translate(1135.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(4.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reset",
    transform: "translate(0.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_refresh_black_24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7083333,5.29166667 C13.5,4.08333333 11.8416667,3.33333333 10,3.33333333 C6.31666667,3.33333333 3.34166667,6.31666667 3.34166667,10 C3.34166667,13.6833333 6.31666667,16.6666667 10,16.6666667 C13.1083333,16.6666667 15.7,14.5416667 16.4416667,11.6666667 L14.7083333,11.6666667 C14.025,13.6083333 12.175,15 10,15 C7.24166667,15 5,12.7583333 5,10 C5,7.24166667 7.24166667,5 10,5 C11.3833333,5 12.6166667,5.575 13.5166667,6.48333333 L10.8333333,9.16666667 L16.6666667,9.16666667 L16.6666667,3.33333333 L14.7083333,5.29166667 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset.b961bc44.svg";
export { ForwardRef as ReactComponent };